import React from "react";
import { actions } from "primarycare-binder";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Divider, Text } from "qdm-component-library";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import CloseIcon from "@material-ui/icons/Close";
import Chip from "@material-ui/core/Chip";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "qdm-component-library";
import { UIColor } from "../../utils";

const styles = (theme) => ({
  autoComplete: {
    '& .MuiInputBase-input': {
      padding: '4.5px 4px !important'
    },
    '& .MuiInputLabel-marginDense': {
      fontSize: 14,
      fontFamily: 'pc_regular'
    },
  },
});

class BookMultipleAppointmentsDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      consultationMode: "",
      practitionerGender: "",
      practitionerPreferredLanguage: [],
      specialties: {},
      language: this.props.allLang ?? []
    };
    this.submitFilter = this.submitFilter.bind(this);
  }

  changeState = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  resetFilter = () => {
    const specialties = {};
    (this.props.selectedSpec || []).forEach(s => {
      specialties[s.value] = true;
    })
    this.setState({
      consultationMode: "",
      practitionerGender: "",
      practitionerPreferredLanguage: [],
      specialties,
    }, () => {
      this.props.resetFilter();
    });
  };

  componentDidMount() {
    let updatedObj = {};
    if (Object.keys(this.props.filterData || {}).length === 0) {
      updatedObj["specialties"] = {};
      (this.props.selectedSpec || []).forEach(s => {
        updatedObj["specialties"][s.value] = true;
      })
    }
    this.setState({
      ...(this.props.filterData || {}),
      ...updatedObj,
    })
  }

  shouldComponentUpdate(props, state) {
    return true;
  }

  submitFilter = () => {
    const data = this.state;
    this.props.ApplyFilter(data)
  }

  selectSpeciality = (name) => {
    let { specialties } = this.state;
    specialties[name] = !specialties[name];
    this.setState({
      specialties
    })
  }

  handleChip = (n, v, l) => {
    const filteredData = this.state.practitionerPreferredLanguage?.filter(l => l?.val !== v?.val);
    this.changeState("practitionerPreferredLanguage", filteredData)
  };


  render() {
    const { specialties } = this.state;
    const { allSpeciality = [], parent_id,classes } = this.props;
    return (
      <div
        id={`${parent_id}_filter_parent_div`}
      >
        <Text
          id={`${parent_id}_filter_label_text`}
          style={{
            fontSize: 16,
            fontWeight: "600",
            color: UIColor.primaryText.color,
            marginLeft: "4%",
          }}
          name={<span>Filter</span>}
        ></Text>
        <div
          id={`${parent_id}_filter_sub_div`}
          style={{ overflow: "auto", height: "80vh" }}>
          <Divider
            id={`${parent_id}_filter_bottom_divider`}
            style={{ marginLeft: 0, marginRight: 0 }} />
          <div
            id={`${parent_id}_filter_Consultation_div`}
            style={{ padding: 20, paddingTop: 0, paddingBottom: 0 }}>
            <div
              id={`${parent_id}_filter_Consultation_sub_div`}
              style={{ marginBottom: "1%" }}>
              <Text
                id={`${parent_id}_filter_Consultation_text`}
                name={
                  <span
                    id={`${parent_id}_filter_Consultation_span`}
                    style={{
                      fontSize: 12,
                      color: UIColor.tertiaryText.color,
                      letterSpacing: "0.9",
                      fontWeight: 600,
                      textTransform: "uppercase",
                    }}
                  >
                    Consultation Mode
                  </span>
                }
              ></Text>
            </div>

            <FormControl
              id={`${parent_id}_filter_Consultation_formcontrol`}
              component="fieldset">
              <RadioGroup
                id={`${parent_id}_filter_Consultation_radioGroup`}
                aria-label="Consultation"
                value={this.state.consultationMode}
                onChange={(e) =>
                  this.changeState("consultationMode", e.target.value)
                }
                name="Consultation"
              >
                <FormControlLabel
                  id={`${parent_id}_filter_direct_formcontrollabel`}
                  value="direct"
                  control={<Radio id="4XAHN7" color="primary" />}
                  label="Direct Consultation"
                />
                <FormControlLabel
                  id={`${parent_id}_filter_video_formcontrollabel`}
                  value="video"
                  control={<Radio id="4XAHN6" color="primary" />}
                  label="Video Consultation"
                />
                <FormControlLabel
                  id={`${parent_id}_filter_Both_formcontrollabel`}
                  value="Both"
                  control={<Radio id="4XAHN5" color="primary" />}
                  label="Both"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <Divider
            id={`${parent_id}_filter_Both_bottom_divider`}
            style={{ marginLeft: 0, marginRight: 0 }} />
          <div
            id={`${parent_id}_filter_Gender_div`}
            style={{ marginTop: "6%", paddingLeft: 20 }}>
            <Text
              id={`${parent_id}_filter_PRACTITIONER_Gender_text`}
              name={
                <span
                  id={`${parent_id}_filter_PRACTITIONER_Gender_span`}
                  style={{
                    fontSize: 12,
                    color: UIColor.tertiaryText.color,
                    letterSpacing: "0.9",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    marginBottom: "1%",
                  }}
                >
                  PRACTITIONER Gender
                </span>
              }
            ></Text>
            <FormControl
              id={`${parent_id}_filter_Gender_formControl`}
              component="fieldset">
              <RadioGroup
                id={`${parent_id}_filter_Gender_radioGroup`}
                row
                aria-label="gender"
                value={this.state.practitionerGender}
                onChange={(e) =>
                  this.changeState("practitionerGender", e.target.value)
                }
                name="gender"
              >
                <FormControlLabel
                  id={`${parent_id}_filter_Gender_male_formControlLabel`}
                  value="Male"
                  control={<Radio id={`${parent_id}_filter_Gender_male_radio`}
                    color="primary" />}
                  label="Male"
                />
                <FormControlLabel
                  id={`${parent_id}_filter_Gender_female_formControlLabel`}
                  value="Female"
                  control={<Radio id={`${parent_id}_filter_Gender_female_radio`} color="primary" />}
                  label="Female"
                />
                <FormControlLabel
                  id={`${parent_id}_filter_Gender_both_formControlLabel`}
                  value="Both"
                  control={<Radio
                    id={`${parent_id}_filter_Gender_both_radio`} color="primary" />}
                  label="Both"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <Divider
            id={`${parent_id}_filter_Gender_bottom_divider`}
            style={{ marginLeft: 0, marginRight: 0 }} />
          <div
            id={`${parent_id}_filter_language_div`}
            className={classes.autoComplete}
            style={{
              marginTop: "6%",
              paddingLeft: 20,
              paddingRight: 20,
              marginBottom: "6%",
            }}
          >
            <Text
              id={`${parent_id}_filter_language_text`}
              name={
                <span
                  id={`${parent_id}_filter_language_span`}
                  style={{
                    fontSize: 12,
                    color: UIColor.tertiaryText.color,
                    letterSpacing: "0.9",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    marginBottom: "1%",
                  }}
                >
                  PRACTITIONER preferred language
                </span>
              }
            ></Text>
            {/* <Autocomplete
              id={`${parent_id}_filter_language_autocomplete`}
              multiple
              options={this.language}
              getOptionLabel={(option) => option.title}
              value={this.state.practitionerPreferredLanguage}
              onChange={(e, value) =>
                this.changeState("practitionerPreferredLanguage", value)
              }
              renderInput={(params) => (
                <TextField
                  id={`${parent_id}_filter_language_search_textfield`}
                  {...params}
                  variant="outlined"
                  label="Search Language here"
                  placeholder="Search Language here"
                />
              )}
              style={{ marginTop: "3%" }}
            /> */}
             <Autocomplete
              id={`${parent_id}_filterdrawer_subtitle_practitioner_preferred_laguange_search_language_autocomplete`}
              size="small"
              multiple
              options={this.state.language}
              value={this.state.practitionerPreferredLanguage}
              getOptionLabel={(option) => option.title}
              filterSelectedOptions
              onChange={(e, value) =>
                this.changeState("practitionerPreferredLanguage", value)
              }
              renderTags={(value, getTagProps) =>
                value.map((option, index) => null)
              }
              renderInput={(params) => (
                <TextField
                  id={`${parent_id}_filterdrawer_subtitle_practitioner_preferred_laguange_search_language_text`}
                  {...params}
                  variant="outlined"
                  label="Search Language here"
                  placeholder="Search Language here"
                />
              )}
              style={{ marginTop: "3%" }}
              className={"pc_regular"}
            />
            {this.state?.practitionerPreferredLanguage?.map((option, index) => {
              return (
                <Chip
                  id={`${parent_id}_${index}_collapse_body_autocomplete_title_chip`}
                  size="medium"
                  label={option.title}
                  deleteIcon={<CloseIcon
                    id={`${parent_id}_${index}_collapse_body_autocomplete_closeicon`}
                    style={{ width: 18, height: 18, color: UIColor.primaryText.color }} />}
                  onDelete={(event) => this.handleChip(event, option, "remove")}
                  // color="primary"
                  variant="outlined"
                  style={{
                    marginRight: 6,
                    marginTop: 6,
                    color: UIColor.primaryText.color,
                    border: `1px solid ${UIColor.differentiationBackground.color}`,
                    backgroundColor: UIColor.differentiationBackground.color,
                  }}
                />
              );
            })}
          </div>
          <Divider
            id={`${parent_id}_filter_language_bottom_divider`}
            style={{ marginLeft: 0, marginRight: 0 }} />
          <div
            id={`${parent_id}_filter_Specialties_div`}
            style={{ marginTop: "6%", paddingLeft: 20 }}>
            <Text
              id={`${parent_id}_filter_Specialties_text`}
              name={
                <span
                  id={`${parent_id}_filter_Specialties_span`}
                  style={{
                    fontSize: 12,
                    color: UIColor.tertiaryText.color,
                    letterSpacing: "0.9",
                    fontWeight: 600,
                    textTransform: "uppercase",
                  }}
                >
                  Specialties
                </span>
              }
            ></Text>
            <div
              id={`${parent_id}_filter_Specialties_checkbox_div`}
            >
              <FormControl
                id={`${parent_id}_filter_Specialties_checkbox_FormControl`}
                component="fieldset">
                {/* <FormControlLabel
                  control={<Checkbox
                    checked={specialties?.["ENT Specialties"]}
                    onChange={() => this.selectSpeciality("ENT Specialties")}
                    name="checkedB" color="primary" />}
                  label="ENT Specialties"
                /> */}
                {
                  allSpeciality.map((val, i) => {
                    return <FormControlLabel
                      id={`${parent_id}_filter_Specialties_FormControllabel`}
                      control={
                        <Checkbox
                        id={`${parent_id}_filter_Specialties_checkbox` + i}
                        checked={specialties[val.value] ? true : false}
                        onChange={() => this.selectSpeciality(val.value)}
                        name="checkedB" color={"primary"} />
                      }
                      label={val.label}
                    />
                  })
                }

                {/* <FormControlLabel
                  control={<Checkbox name="checkedB" color="primary" />}
                  label="Both"
                /> */}
              </FormControl>
            </div>
          </div>
        </div>
        <Divider
          id={`${parent_id}_filter_Specialties_bottom_divider`}
          style={{ marginLeft: 0, marginRight: 0 }} />
        <div
          id={`${parent_id}_filter_button_div`}
          style={{
            padding: "10px 20px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent:"space-between",
          }}
        >
          <Button
            id={`${parent_id}_filter_reset_button`}
            variant="outlined"
            onClick={this.resetFilter}
            style={{
              width: "50%",
              height: 32,
              padding: "8px 10px",
              fontSize: 13,
              backgroundColor: "#ffffff",
              color: "rgb(236, 106, 73)",
              border: "1px solid rgb(236, 106, 73)",
              borderRadius: 4
            }}
            disabled={this.props?.docterListing?.loading}
          >
            Reset
          </Button>
          <Button
            id={`${parent_id}_filter_Apply_button`}
            style={{
              width: "50%",
              height: 32,
              padding: "8px 10px",
              fontSize: 13,
              backgroundColor: UIColor.primaryColor.color,
              border: UIColor.primaryColor.color,
              borderRadius: 4,
              marginLeft: 12
            }}
            disabled={this.props?.docterListing?.loading}
            onClick={() => this.submitFilter()}
          >
            {
              this.props?.docterListing?.loading
                ? "Applying"
                : "Apply"
            }
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  docterListing: state?.docterListingReducer?.docterListing,
});

export default withStyles(styles)(connect(
  mapStateToProps,
  actions
)(withRouter(BookMultipleAppointmentsDrawer)));
